import { render } from "./secciones.vue?vue&type=template&id=4b88c385"
import script from "./secciones.vue?vue&type=script&lang=js"
export * from "./secciones.vue?vue&type=script&lang=js"

import "./secciones.vue?vue&type=style&index=0&id=4b88c385&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__